import React from "react";
import DataBox from "./DataBox";
import ScheduleDisplay from "./ScheduleDisplay";
import jobTitleIcon from "assets/images/job-title.svg";
import jobTypeIcon from "assets/images/job-type.svg";
import departmentIcon from "assets/images/departmentIcon.svg";
import reportsToIcon from "assets/images/reportsToIcon.svg";
import jobScheduleIcon from "assets/images/job-schedule.svg";
import jobAccessIcon from "assets/images/job-access.svg";
import * as moment from "moment";
import SectionHeader from "./SectionHeader";
import styles from "../staff.module.scss";

const RoleDetailsSection = ({
  designation,
  staffRoleId,
  departmentName,
  reportToName,
  schedules,
  employmentDate,
  isAdmin,
  t,
  children,
  staffDetails,
  globalStaffPage,
}) => {
  return (
    <div className={`green-main-color-form ${styles["p-20"]}`}>
      {globalStaffPage && (
        <SectionHeader className="mb-3">
          {staffDetails?.office?.name}
        </SectionHeader>
      )}
      <DataBox icon={jobTitleIcon} label="Employment Role">
        {designation}
      </DataBox>

      <DataBox icon={jobTypeIcon} label={t("accountOwner.jobType")}>
        {staffRoleId === 1
          ? t("form.values.temporary")
          : t("form.values.permanent")}
      </DataBox>

      <DataBox icon={departmentIcon} label="Department/Team">
        {departmentName || "--"}
      </DataBox>

      <DataBox icon={reportsToIcon} label="Reports To">
        {reportToName || "--"}
      </DataBox>

      <DataBox
        icon={jobScheduleIcon}
        label={t("form.fields.schedule")}
        directChild
      >
        {schedules?.length > 0 && <ScheduleDisplay schedules={schedules} />}
      </DataBox>

      <DataBox
        icon={jobScheduleIcon}
        label={t("staffTimesheet.sortByEmploymentDate")}
      >
        {employmentDate ? moment(employmentDate).format("Do MMMM YYYY") : "--"}
      </DataBox>
      {isAdmin && (
        <DataBox icon={jobAccessIcon} label={t("accountOwner.access")}>
          {t("accountAdmin")}
        </DataBox>
      )}
      {children}
    </div>
  );
};

export default RoleDetailsSection;
